import moment from 'moment'

const UTCFormatInCurrentTimezone = (date, inputFormat = 'YYYY-MM-DD HH:mm', outgoingFormat) => {
  if (outgoingFormat !== null) {
    return moment.utc(date, inputFormat)
      .tz(moment.tz.guess())
      .format(outgoingFormat)
  }
  return moment.utc(date, inputFormat).tz(moment.tz.guess())
}

const currentTimezoneFormatInUTC = (date, inputFormat = 'YYYY-MM-DD HH:mm', outgoingFormat = 'YYYY-MM-DD HH:mm') => {
  return moment.tz(date, inputFormat, moment.tz.guess())
    .utc()
    .format(outgoingFormat)
}

export { UTCFormatInCurrentTimezone, currentTimezoneFormatInUTC }
